import {Col, Row} from "antd";
import './Desktop.css';

export function getDesktopRender() {
    return (<div className="desktop-background">
        <Row style={{paddingTop: '100px'}}>
            <Col span={8}/>
            <Col span={8}>
                <img src="/images/cartoon.png" style={{maxWidth: '100%', height: 'auto'}}/>
            </Col>
            <Col span={8}/>
        </Row>
        <Row>
            <Col span={8}/>
            <Col span={8}>
                <img src="/images/kimchi-tong-text.png" style={{
                    width: '80%',
                    height: 'auto',
                    marginTop: '10%',
                    marginLeft: '10%'
                }}/>
            </Col>
            <Col span={8}/>
        </Row>
        <Row>
            <Col span={8}/>
            <Col span={4}>
                <img src="/images/got-kimchi-text.png" style={{
                    width: '90%',
                    height: 'auto',
                    marginTop: '10%',
                    marginLeft: '5%'
                }}/>
            </Col>
            <Col span={4}>
                <img src="/images/chongak-kimchi-text.png" style={{
                    width: '90%',
                    height: 'auto',
                    marginTop: '10%',
                    marginLeft: '5%'
                }}/>
            </Col>
            <Col span={8}/>
        </Row>
        <Row>
            <Col span={8}/>
            <Col span={8} style={{marginTop: '5%'}}>
                <div className='image-container'
                     onClick={() => window.open('https://mint.club/token/klaytn/KIMCHI_T', '_blank')}
                     style={{cursor: 'pointer'}}>
                    <img src="/images/buy-kimchi-tong.png"/>
                    <p> 지금 김치통은 : ? $</p>
                </div>
            </Col>
            <Col span={8}/>
        </Row>
        <Row style={{marginTop: '1%'}}>
            <div style={{width: '100%', textAlign: "center", fontSize: '2vw'}}>
                <a href="https://open.kakao.com/o/gYchwCog" target="_blank">https://open.kakao.com/o/gYchwCog</a>
            </div>
        </Row>

        <Row style={{marginTop: '1%'}}>
            <div style={{width: '100%', textAlign: "center", fontSize: '2vw'}}>
                <a href="https://twitter.com/0xkimchilabs" target="_blank">https://twitter.com/0xkimchilabs</a>
            </div>
        </Row>
        <Row style={{marginTop: '1%'}}>

            <Col span={6}/>
            <Col span={12}>
                <div style={{
                    border: "2px solid black",
                    width: '100%',
                    height: 'auto',
                    backgroundColor: 'white'
                }}>
                    <p style={{textAlign: 'center', fontWeight: 'bold', fontSize: '2vw'}}>Kimchi Warrior NFT</p>
                    <img src="/images/kimchi-man.png" style={{
                        width: '50%',
                        marginLeft: '25%',
                        height: 'auto',
                    }}/>
                    <p style={{textAlign: 'center', fontSize: '1vw'}}>
                        o자산들과 맞서 싸웠던 김치 전사들에게 민팅됩니다.<br/>
                        김치 전사들에게는 김치통이 에어드랍됩니다.<br/>
                        추후 김치 전사들을 위한 축전이 있습니다. (24.3Q)</p>
                    <p style={{textAlign: 'center', fontWeight: 'bold', fontSize: '1.8vw'}}>김치 전사의 전당</p>
                    <div className='warrior-address-wrapper'>
                        <span
                            style={{fontSize: '1vw'}}>1. 0x0000000000000000000000000000000000000000 : </span>
                        <span style={{fontSize: '1vw', color: 'red'}}> 약 304,082 oUSDT</span>
                    </div>
                    <div className='warrior-address-wrapper'>
                        <span
                            style={{fontSize: '1vw'}}>2. 0x0000000000000000000000000000000000000000 : </span>
                        <span style={{fontSize: '1vw', color: 'red'}}> 약 204,082 oUSDT</span>
                    </div>
                    <div className='warrior-address-wrapper'>
                        <span
                            style={{fontSize: '1vw'}}>와 같이 o 자산 보유 순위가나와버릴거라구! 너흰 김치전사야! (TBD)</span>
                    </div>
                    <p/>
                </div>
            </Col>
            <Col span={6}/>
        </Row>
        <Row style={{marginTop: '2%'}}>
            <Col span={6}/>
            <Col span={12}>
                <div style={{
                    border: "1px solid black",
                    width: '100%',
                    height: '100%',
                    backgroundImage: 'url(/images/kimchi-background.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}>
                    <h1 style={{color: 'black', marginTop: '4%', textAlign: "center"}}>김치의 효능</h1>
                    <div style={{
                        marginTop: "3%",
                        width: '90%',
                        marginLeft: "5%",
                        display: 'flex', // Flexbox 레이아웃 활성화
                        alignItems: 'center'
                    }}>
                        <img src='/images/got-kimchi.png' style={{width: "25%", height: "auto"}}/>

                        <div style={{
                            width: '75%',
                            height: "auto",
                            paddingLeft: '5%'
                        }}>
                            <p style={{fontSize: "1.2vw", color: "rgba(234, 0, 0, 1)", fontWeight: "bold"}}>
                                갓 김치 (GOD kimchi)
                            </p>
                            <p style={{fontSize: "1vw", color: "black"}}> 갓김치는 항산화 비타민과 항세균 성분이 풍부하여
                                <span style={{color: "rgba(234, 0, 0, 1)"}}> 김치 프리미엄을 증강시키는 효과가 있다.</span> 갓김치를 만들면 김치
                                프리미엄 상승에 따라 김치통이
                                에어드랍되고, 각종 성인병의 예방 및 치료에 도움을 준다.
                                김치통에 김장가능(24.6월)하며 오래두면 쉰김치가 된다.</p>
                        </div>
                    </div>


                    <div style={{
                        marginTop: "3%",
                        width: '90%',
                        marginLeft: "5%",
                        display: 'flex', // Flexbox 레이아웃 활성화
                        alignItems: 'center'
                    }}>
                        <img src='/images/chongak-kimchi.png' style={{width: "25%", height: "auto"}}/>

                        <div style={{
                            width: '75%',
                            height: "auto",
                            paddingLeft: '5%'
                        }}>
                            <p style={{fontSize: "1.2vw", color: "rgba(0, 69, 247, 1)", fontWeight: "bold"}}>
                                총각 김치(ChongGak kimchi)
                            </p>
                            <p style={{fontSize: "1vw", color: "black"}}>총각 김치는 뇌활성 아미노산인 가바가 풍부하게 함유되어 있어 노인성치매를 예방해주며
                                <span style={{color: "rgba(0, 69, 247, 1)"}}> 김치 프리미엄을 감소시키는 효과가 있다.</span> 총각 김치를 만들면
                                김치 프리미엄 하락에 따라 김치통이 에어드랍되고, 김치에 들어있는 식이섬유와 향신료 유산균은 나쁜
                                콜레스트롤을 떨어뜨린다. 김치통에 김장가능(24.6월)하며 오래두면 쉰김치가 된다.</p>
                        </div>
                    </div>


                    <div style={{
                        marginTop: "3%",
                        width: '90%',
                        marginLeft: "5%",
                        display: 'flex', // Flexbox 레이아웃 활성화
                        alignItems: 'center'
                    }}>
                        <img src='/images/shin-kimchi.png' style={{width: "25%", height: "auto"}}/>

                        <div style={{
                            width: '75%',
                            height: "auto",
                            paddingLeft: '5%'
                        }}>
                            <p style={{fontSize: "1.2vw", color: "rgba(103, 68, 0, 1)", fontWeight: "bold"}}>
                                쉰 김치 (GOD kimchi)
                            </p>
                            <p style={{fontSize: "1vw", color: "black"}}> 김치를 오래두면 쉰김치가 된다. 김치통의 디플레이션 요소지만 어딘가엔 쓸모가
                                있어보인다.</p>
                        </div>
                    </div>


                </div>
            </Col>
            <Col span={6}/>
        </Row>
        <Row style={{marginTop: "5%", marginBottom: "5%"}}>
            <Col span={6}/>
            <Col span={12}>
                <img src="/images/kimchi-roadmap.png" style={{width: "100%", height: "auto"}}/>
            </Col>
            <Col span={6}/>
        </Row>
    </div>)
}
